<template>
  <Btn :label="label" :disabled="disabled" icon="mdi-content-save" isCheckRole @click="onClick" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnSave',
  components: {
    Btn,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0019')
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
